import throttle from 'lodash.throttle'

const windowIsDefined = typeof window !== 'undefined'

class ScrollObserver {
  constructor () {
    this._callbacks = []
    this._lastScroll = windowIsDefined ? window.pageYOffset : 0

    this._scrollData = () => {
      const currentScroll = window.pageYOffset
      const scrollDiff = this._lastScroll - currentScroll
      const footerScrollPosition = window.innerHeight - document.body.offsetHeight


      this._lastScroll = currentScroll

      return {
        currentScroll,
        scrollDiff,
        footerScrollPosition
      }
    }

    this._handleScroll = () => {
      const scrollData = this._scrollData()

      this._callbacks.forEach( (v) => {
        const { element, fn } = v
        fn.call(element, scrollData)
      })
    }

    if (windowIsDefined) {
      window.addEventListener("scroll", throttle(this._handleScroll), {
        passive: true
      })
      window.addEventListener("resize", throttle(this._handleScroll, 60, {
        leading: false
      } ))
    }
  }

  removeAllCallbacks (obj) {
    this._callbacks.filter((v, i, a) => {
      if (obj === v.element) {
        delete a[i]
      }
    })
  }

  removeCallback (obj, fn) {
    this._callbacks.filter((v, i, a) => {
      if (obj === v.element && fn === v.fn) {
        delete a[i]
      }
    })

  }

  addCallback (obj, fn) {
    if (typeof fn === 'function') {
      this._callbacks.push({
        element: obj,
        fn: fn
      })
    } else {
      throw new Error(`Can't add ${typeof fn} as a callback. Needs to be a 'function'`)
    }

    return this
  }
}

export default new ScrollObserver()
